import { FormGroup, styled } from "@mui/material";

export const FilterFormGroup = styled(FormGroup)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "16px",
  rowGap: "4px",
}));
